var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.$isPc && _vm.$route.path !== '/install' )?_c('ok-header'):_vm._e(),_c('router-view'),(_vm.$mode == 1 && !_vm.$isPc && _vm.$route.path !== '/install')?_c('ok-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }